import { Component, Input, Output, EventEmitter, OnInit, DoCheck } from '@angular/core';
import {Router} from "@angular/router";
import * as moment from 'moment';

@Component({
  selector: 'services-list',
  templateUrl: '../../templates/partials/list-services.html'
})
export class ListServicesComponent implements OnInit{

    @Input() services;
    @Input() filter;
    @Input() search;
    @Output() changeDate = new EventEmitter();
    @Output() clearSearchEmitter = new EventEmitter();
    @Output() modalCommentsEmitter = new EventEmitter();
    @Input() assignment;
    public page: number = 1;
    public showPager = true;
    public selected: number;
    public daysArray: Array<any> = [];
    public searchDataParsed = '';
    constructor(private router:Router){}

    public goToDetail(id){
      this.router.navigate(['/services', id]);
    }

    public selectDate(element: object){
      this.selected = <number>element["index"];
      this.changeDate.emit(element)
    }

    public clearSearch() {
        this.clearSearchEmitter.emit();
        this.searchDataParsed = '';
        this.selected = 1;
    }

    public showModal($event: any, service: object){
      $event.stopPropagation();
      this.modalCommentsEmitter.emit(service);
    }

    ngOnChanges(changes: any) {
      
      if(this.search != null){
        this.parseSearchFilters();
      }
    }

    public parseSearchFilters() {
        this.searchDataParsed = '';
        this.searchDataParsed += (this.search["serviceCode"]) ? this.search["serviceCode"] + ' ' : '';
        this.searchDataParsed += (this.search["clientName"]) ? this.search["clientName"] + ' ' : '';
        this.searchDataParsed += (this.search["cleanerName"]) ? this.search["cleanerName"] + ' ' : '';
        this.searchDataParsed += (this.search["email"]) ? this.search["email"] + ' ' : '';
        this.searchDataParsed += (this.search["street"]) ? this.search["street"] + ' ' : '';
        this.searchDataParsed += (this.search["dateMin"]) ? moment(this.search["dateMin"],"YYYY-MM-DD").format("DD/MM/YYYY") + ' ' : '';
        this.searchDataParsed += (this.search["dateMax"]) ? moment(this.search["dateMax"],"YYYY-MM-DD").format("DD/MM/YYYY") + ' ' : '';
    }

    public addPage(){
        this.page++;
        if(this.services.length <= (this.page * 20)){
            this.showPager = false;
        }        
    }

    public setClass(service){
        if(service.canceled == 0 && (service.done == 1 || service.isBefore || (service.isSame && service.now >= service.time_end))){
          return 'c-slat--done';
        }else if(service.canceled == 1){
          return 'c-slat--canceled';
        }
        else if(service.now >= service.time_ini && service.now < service.time_end && service.isSame){
          return 'c-slat--course';
        }
    }

    ngOnInit() {
      moment.locale("es");
      /*var date, day, formatDate;
      for(var i = 0; i < 6; i++){
    
        if(i == 0){
          date = moment().subtract(1, 'days').format("DD/MM");
          day = moment().subtract(1, 'days').format("dd");
          formatDate = moment().subtract(1, 'days').format("YYYY-MM-DD");
        }
        if(i == 1){
          date = moment().format("DD/MM");
          day = moment().format("dd");
          formatDate = moment().format("YYYY-MM-DD");
          this.selected = i;
        }else{
          date = moment().add(i - 1, 'days').format("DD/MM");
          day = moment().add(i - 1, 'days').format("dd");
          formatDate = moment().add(i - 1, 'days').format("YYYY-MM-DD");
        }
        this.daysArray.push({ index: i, date: date, day: day, formatDate: formatDate })
      }*/
    }

}


// WEBPACK FOOTER //
// ./src/app/modules/services/components/dummy/list-services.component.ts